import { IDeductionsByPurchaserItem } from "@/core/repositories/analytics";
import {
  ANALYTICS_OTHERS_LABEL,
  MAX_TOP_ANALYTICS_ROWS,
  MIN_ANALYTICS_SHARE_PERCENT,
} from "./constants";

export type PurchaserChartMetric = "amount" | "count";

export interface PurchaserChartItem {
  purchaserName: string;
  amount: number;
  count: number;
  share: number;
  isOther: boolean;
}

const aggregateOthers = (rows: IDeductionsByPurchaserItem[]): PurchaserChartItem => ({
  purchaserName: ANALYTICS_OTHERS_LABEL,
  amount: rows.reduce((total, row) => total + row.amount, 0),
  count: rows.reduce((total, row) => total + row.count, 0),
  share: rows.reduce((total, row) => total + row.share, 0),
  isOther: true,
});

export const groupPurchasersWithOther = (
  items: IDeductionsByPurchaserItem[],
  metric: PurchaserChartMetric
): PurchaserChartItem[] => {
  const eligible = items.filter(item => item.share >= MIN_ANALYTICS_SHARE_PERCENT);
  const belowThreshold = items.filter(item => item.share < MIN_ANALYTICS_SHARE_PERCENT);

  const sortedEligible = [...eligible].sort((first, second) => second[metric] - first[metric]);
  const topRows = sortedEligible.slice(0, MAX_TOP_ANALYTICS_ROWS);
  const overflowRows = sortedEligible.slice(MAX_TOP_ANALYTICS_ROWS);
  const othersSource = [...overflowRows, ...belowThreshold];

  const mappedTopRows: PurchaserChartItem[] = topRows.map(item => ({
    purchaserName: item.purchaser.purchaserName,
    amount: item.amount,
    count: item.count,
    share: item.share,
    isOther: false,
  }));

  if (othersSource.length === 0) {
    return mappedTopRows;
  }

  return [...mappedTopRows, aggregateOthers(othersSource)];
};
